<div class="months">
  <calendar-month
    (selectedDate)="setDate($event)"
    (hoveredDate)="showDate($event)"
    [date]="leftCalendar"
    [start]="startDate"
    [end]="endDate"
    [min]="min"
    [max]="max"
    [firstDayOfWeek]="firstDayOfWeek"
    [active]="active"
    side='start'
  ></calendar-month>
  <calendar-month
    (selectedDate)="setDate($event)"
    (hoveredDate)="showDate($event)"
    [date]="rightCalendar"
    [start]="startDate"
    [end]="endDate"
    [min]="min"
    [max]="max"
    [firstDayOfWeek]="firstDayOfWeek"
    [active]="active"
    side='end'
  ></calendar-month>
</div>
